import { useSyncExternalStore } from 'react';
import { getTheme, type ThemeManifest } from '@/lib/themes';

function subscribe(callback: () => void) {
  const observer = new MutationObserver(callback);
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['data-theme'],
  });
  return () => observer.disconnect();
}

function getSnapshot(): string {
  return document.documentElement.getAttribute('data-theme') ?? 'default';
}

function getServerSnapshot(): string {
  return 'default';
}

export function useThemePreset(): string {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}

export function useTheme(): ThemeManifest {
  return getTheme(useThemePreset());
}
